<template>
  <v-layout row>
    <v-flex xs12 md10 offset-md1>
      <groupish type="approval" @input="createFlow"/>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex';
  import Groupish from '@/views/shared/groupish/Groupish';

  export default {
    components: { Groupish },
    methods: {
      createFlow(flow) {
        this.$services.authenticator.post('/approvals/flows', flow)
          .then((response) => {
            this.show('Approval flow created');
            this.resetFlows();
            this.$router.replace(`/approvals/flows/${response.data.data.id}`);
          }).catch(this.$defaultHandlerHttp);
      },
      ...mapActions('alert', [
        'show'
      ]),
      ...mapActions('approvals', [
        'resetFlows'
      ])
    }
  };
</script>

<style scoped>

</style>
